module.exports = __webpack_public_path__ + "img/ps-9.ea474581.jpg";